import React, { useEffect, useRef } from 'react';

const HubSpotForm = ({ portalId, formId }) => {
    // Create a stable unique ID for the container
    const uniqueId = `hubspot-form-${formId}`;
    const hasLoaded = useRef(false);

    useEffect(() => {
        const scriptId = 'hs-script-loader';
        let script = document.getElementById(scriptId);

        const renderForm = () => {
            if (window.hbspt && window.hbspt.forms) {
                // Prevent double rendering
                if (hasLoaded.current) return;

                const targetElement = document.getElementById(uniqueId);

                // Double check target exists
                if (!targetElement) {
                    console.error('[HubSpotForm] Target element not found:', uniqueId);
                    return;
                }

                // Clean container
                targetElement.innerHTML = '';

                // Create form
                window.hbspt.forms.create({
                    portalId: portalId,
                    formId: formId,
                    target: `#${uniqueId}`,
                    cssRequired: `
                        .submitted-message { color: #ffffff !important; }
                        .hs-form-field > label { color: #ffffff !important; font-weight: 500 !important; font-size: 0.9rem !important; }
                        .hs-form-field .hs-error-msgs label { color: #ffcccc !important; }
                        .hs-input { background-color: rgba(255, 255, 255, 0.08) !important; color: #ffffff !important; border: 1px solid rgba(255, 255, 255, 0.15) !important; border-radius: 6px !important; }
                        .hs-input::placeholder { color: rgba(255, 255, 255, 0.35) !important; }
                        .hs-input:focus { border-color: rgba(42, 82, 152, 0.6) !important; outline: none !important; }
                        .hs-button { background: #2a5298 !important; border: 1px solid rgba(42, 82, 152, 0.8) !important; color: #ffffff !important; font-weight: 600 !important; border-radius: 8px !important; padding: 0.65rem 1.5rem !important; cursor: pointer !important; }
                        .hs-button:hover { background: #3565b5 !important; }
                        .hs-richtext { color: rgba(255, 255, 255, 0.6) !important; }
                        .hs-fieldtype-intl-phone .hs-input { color: #333 !important; }
                        .hs-form select { color: #ffffff !important; background-color: rgba(255, 255, 255, 0.08) !important; }
                    `
                });

                hasLoaded.current = true;
                console.log('[HubSpotForm] Form created in target:', uniqueId);
            }
        };

        if (!script) {
            script = document.createElement('script');
            script.id = scriptId;
            script.src = '//js.hsforms.net/forms/embed/v2.js';
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);

            script.addEventListener('load', renderForm);
        } else {
            if (window.hbspt && window.hbspt.forms) {
                renderForm();
            } else {
                script.addEventListener('load', renderForm);
                // Fallback: poll in case load event was missed
                const interval = setInterval(() => {
                    if (window.hbspt && window.hbspt.forms) {
                        clearInterval(interval);
                        renderForm();
                    }
                }, 100);
                setTimeout(() => clearInterval(interval), 5000);
            }
        }

        return () => {
            if (script) {
                script.removeEventListener('load', renderForm);
            }
        };
    }, [portalId, formId, uniqueId]);

    return (
        <div
            id={uniqueId}
            className="hubspot-form-container"
            style={{
                minHeight: '100px',
                width: '100%'
            }}
        />
    );
};

export default HubSpotForm;
